import { Component } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { AuthenticationService, UserModel } from '@kaiser-software/chassis-core';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-add-observation-header-button-plugin',
    templateUrl: 'add-observation-header-button.plugin.html',
    styleUrls: ['add-observation-header-button.plugin.scss']
})
export class AddObservationHeaderButtonPlugin {

    /**
     * @param authenticationService
     */
    constructor(
        protected authenticationService: AuthenticationService,
    ) {
        //
    }

    public isVisible(): Observable<boolean> {
        return new Observable((observer: Observer<boolean>) => {
            this.authenticationService.user()
                .pipe(
                    filter((user: UserModel) => {
                        return !!user;
                    })
                )
                .subscribe((user: UserModel) => {
                    observer.next(
                        user.tenant_scope
                    );
                });
        });
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/plugins/add-observation-header-button/add-observation-header-button.plugin.ts